export default __webpack_public_path__ + "static/media/detalii_apartament_40-min.bdfd1565.jpg";